'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
export const w = {
  product: 'FW27 cognac box tote',
  size: '38 \xD7 30 \xD7 14 cm',
  quantity: 300,
  currency: 'EUR',
  recommendation:
    'Italian full-package production, preferably Florence, with Casa Orvieto approving materials and the finished sample.',
  cost: [
    {
      label: 'Packed unit, factory',
      low: 180.03,
      base: 276.16,
      high: 456.49,
    },
    {
      label: 'Unit incl. development, tooling, tests',
      low: 193.37,
      base: 297.83,
      high: 489.82,
    },
    {
      label: 'Recurring production, 300 units',
      low: 54010,
      base: 82848,
      high: 136946,
    },
    {
      label: 'One-offs',
      low: 4e3,
      base: 6500,
      high: 1e4,
    },
    {
      label: 'Freight to Milan',
      low: 600,
      base: 900,
      high: 1500,
    },
    {
      label: '10% contingency',
      low: 5861,
      base: 9025,
      high: 14845,
    },
    {
      label: 'Planning envelope (ex VAT)',
      low: 64471,
      base: 99273,
      high: 163291,
    },
  ],
  reserve: 1e5,
  routes: [
    {
      name: 'Full-package',
      verdict: 'Recommended',
      why: 'One party owns cutting yield, materials, assembly and delivery.',
    },
    {
      name: 'Nominated component',
      verdict: 'Good hybrid',
      why: 'Once the leather article is approved.',
    },
    {
      name: 'Assembly only',
      verdict: 'Not for a first run',
      why: 'A low price can hide material cash and shortage exposure.',
    },
    {
      name: 'White label',
      verdict: 'Faster, not equivalent',
      why: 'Existing geometry won\u2019t match the box tote.',
    },
  ],
  regions: [
    {
      name: 'Florence / Tuscany',
      unit: '\u20AC180\u2013456',
      moq: '100\u2013300 per style',
      lead: '8\u201312 weeks',
    },
    {
      name: 'Lombardy',
      unit: '\u20AC177\u2013445',
      moq: '100\u2013300 per style',
      lead: '8\u201314 weeks',
    },
  ],
  leadsQualified: 3,
  material:
    'Full-grain vegetable-tanned calf, 1.80 \xB10.15 mm; welted base; two concealed magnet pairs.',
  conflicts: [
    'Handle blank length vs 240 mm drop',
    'Seam allowance (6 / 9 / 10 mm)',
    'Pocket size',
    'Closure geometry',
  ],
  delivery: 'Milan receipt by 15 July 2027 (target, not a supplier promise)',
};
export const T = {
  components: 22,
  measurements: 65,
  measurementNote: 'each with a target, tolerance and verification method',
  bomItems: 40,
  operations: 19,
  layers: 24,
  joins: 19,
  qualityChecks: 12,
  engineeringReviews: 6,
  componentImages: {
    done: 12,
    of: 22,
  },
  colorways: ['Cognac', 'Ink', 'Olive'],
  open: [
    'Sketch sheets',
    'Back and side reference views',
    'Stitch colour: contrast or tone-on-tone',
  ],
  status: 'Draft for technical review, not factory-ready.',
};
export const referenceBrands = {
  lisiere: {
    name: 'LISI\xC8RE',
    city: 'New York',
    kind: 'Ready-to-wear \xB7 tailoring and knitwear',
    role: 'The hero collection: plan to market',
  },
  orvieto: {
    name: 'Casa Orvieto',
    city: 'Milan',
    kind: 'Leather goods \xB7 made in Italy',
    role: 'Production depth: tech pack, cost, samples, factory handoff',
  },
  aubrac: {
    name: 'Maison Aubrac',
    city: 'Paris',
    kind: 'Women\u2019s ready-to-wear and accessories',
    role: 'Brand and launch: identity, campaign, product pages',
  },
  mercer: {
    name: 'Mercer & Vale',
    city: 'SoHo, New York',
    kind: 'Brand-owner company \xB7 womenswear and home',
    role: 'Running the business: finance, apps, Your IMAI, schedules',
  },
};
export const collectionFacts = {
  blurb:
    'Plan and build anything from one new product to an entire seasonal collection\u2014then prepare it for channels and buyers.',
  stages: [
    {
      key: 'plan',
      label: 'Plan',
      workflows: [
        {
          name: 'Create a Collection',
          does: 'Market and trend research through direction, line planning, product concepts, colors, materials and briefs, in one workflow.',
        },
        {
          name: 'Forecast Trends',
          does: 'Market signals, emerging themes, colors and materials in a visual report with sources.',
        },
        {
          name: 'Set Collection Direction',
          does: 'Compare distinct routes with source evidence and clear conditions for each decision.',
        },
        {
          name: 'Build a Line Plan',
          does: 'Product roles, categories, price points, launch timing, and how many options of each.',
        },
      ],
    },
    {
      key: 'develop',
      label: 'Develop',
      workflows: [
        {
          name: 'Create Product Stories',
          does: 'Each product\u2019s purpose, customer, design idea and role in the collection.',
        },
        {
          name: 'Plan Colors and Materials',
          does: 'A coordinated palette and material plan, assigned across products.',
        },
        {
          name: 'Create Production Briefs',
          does: 'Product briefs with technical gaps and readiness made clear.',
        },
      ],
    },
    {
      key: 'approve',
      label: 'Approve',
      workflows: [
        {
          name: 'Review the Collection',
          does: 'Every product against the approved direction, mix, price points and targets; gaps and overlaps flagged.',
        },
        {
          name: 'Lock the Collection',
          does: 'A freeze packet with versions, accepted decisions and open conditions.',
        },
      ],
    },
    {
      key: 'sell',
      label: 'Sell',
      workflows: [
        {
          name: 'Create a Channel Assortment',
          does: 'Adapt the locked collection to each channel without changing the core line.',
        },
        {
          name: 'Create a Buyer Package',
          does: 'Collection story, hero products, pricing, delivery windows and line sheet buyers can act on.',
        },
      ],
    },
  ],
};
export const productionFacts = {
  sections: [
    'Technical Development',
    'Sourcing & Costing',
    'Samples & Approval',
    'Production Release',
  ],
  workflows: [
    {
      name: 'Build a Detailed Tech Pack',
      does: 'Drawings, measurements, materials, construction, colorways, tolerances and revisions in one editable pack.',
    },
    {
      name: 'Build a Quick Tech Pack',
      does: 'Seven editable modules with component and schematic images in one dashboard.',
    },
    {
      name: 'Plan Sourcing and Costing',
      does: 'Compare paths by capability, materials, volume, location, minimum orders, lead time and quality.',
    },
    {
      name: 'Compare Supplier Quotes',
      does: 'Quotes side by side.',
    },
    {
      name: 'Build a Product Cost Sheet',
      does: 'An editable cost sheet.',
    },
    {
      name: 'Prepare a Supplier RFQ',
      does: 'A request for quotation ready to send after your review.',
    },
    {
      name: 'Request a Product Sample',
      does: 'A sample request.',
    },
    {
      name: 'Review a Product Sample',
      does: 'One redline pack for the supplier.',
    },
    {
      name: 'Run a Production Readiness Review',
      does: 'Go, Conditional Go or Hold.',
    },
    {
      name: 'Prepare the Factory Handoff',
      does: 'The latest pack, BOM, specs and approvals in one handoff.',
    },
  ],
  caveat:
    'It provides a structured starting point. A technical designer still reviews and approves measurements, tolerances, grading, construction, materials and production requirements.',
};
export const marketFacts = {
  workflows: [
    {
      name: 'Plan a Launch',
      does: 'A launch plan for the drop.',
    },
    {
      name: 'Plan a Campaign',
      does: 'Audience, idea and channels.',
    },
    {
      name: 'Create a Campaign Kit',
      does: 'On-brand visuals and copy for the campaign.',
    },
    {
      name: 'Create a Product Video',
      does: 'Product video with sound.',
    },
    {
      name: 'Create Product Listing Images',
      does: 'Listing images from the approved product.',
    },
    {
      name: 'Build Product Page Content',
      does: 'Product page copy and structure.',
    },
    {
      name: 'Create a Marketing Email',
      does: 'A launch email.',
    },
    {
      name: 'Read Market Response',
      does: 'What sold and why, from your store, analytics or uploads.',
    },
  ],
  approval:
    'Approved content can be sent to connected platforms where direct publishing is supported. Your team controls approval, scheduling and release.',
};
